import React from "react";
import PostsComponent from "../components/Post";
import BlogBg from "../assets/img/serviceBg.png";

const Blog = () => {
  return (
    <div className="container mx-auto px-4">
       <div className="block bg-white h-[130px]"></div>
      <div className="relative w-full h-[200px] md:h-[280px] overflow-hidden group rounded-3xl">
        <img
          src={BlogBg}
          alt="Background"
          className="w-full h-full object-cover rounded-3xl transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
            Blog
          </h1>
        </div>
      </div>

      <section className="">
        {/* Section Title */}

        <PostsComponent />
      </section>

    </div>
  );
};

export default Blog;
